export default "__VITE_ASSET__Dm7n$ZGw__"